<template>
    <div :id="id" :name="name">

    </div>
</template>


<script>
    import _Quill from 'quill';
    import "quill/dist/quill.snow.css";

    import * as Mention from 'quill-mention';
    import 'quill-mention/dist/quill.mention.css';

    // import * as QuillTableUI from 'quill-table-ui';

    const Quill = window.Quill || _Quill;

    const sizeStyle = Quill.import('attributors/style/size')
    sizeStyle.whitelist = ['5px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
    Quill.register(sizeStyle, true)

    // Quill.register({
    //     'modules/tableUI': QuillTableUI.default
    // }, true);

    // Quill.register({
    //     'modules/mention': mention
    // }, true);

    Quill.register({
        'modules/mention': Mention.default
    }, true);

    export default {
        name: 'quill-container',
        props: ['value', 'id', 'name', 'options', 'mentionFrom'],
        data() {
            return {
                instance: null,
                userInput: false,
                atValues: []
            }
        },
        mounted() {
            this.createInstance();
            this.instance.container.firstChild.innerHTML = this.value;
            Bus.$on('QuillChangeValue', (value) => {
                this.instance.container.firstChild.innerHTML = value;
            });
        },
        watch: {
            value() {
                if (!this.userInput) {
                    this.instance.container.firstChild.innerHTML = this.value;
                } else {
                    this.userInput = false;
                }
            },
            options() {
                this.atValues = this.options.map(this.mapValues);
            }
        },
        methods: {
            createInstance() {

                var toolbarOptions = [
                    [{ 'size': [false, '5px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px'] }],  // custom dropdown
                    // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote'],

                    [{'align': null}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],

                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],

                    ['image'],
                    // ['table'],

                    ['clean']                                         // remove formatting button
                ];

                this.instance = new Quill('#' + this.id, {
                    modules: {
                        mention: {
                            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
                            mentionDenotationChars: ["@", "#"],
                            source: this.renderMentions,
                            onSelect: this.emitMention
                        },
                        // table: true,
                        // tableUI: true,
                        toolbar: toolbarOptions,
                    },
                    theme: 'snow'
                });

                this.instance.on('text-change', this.emit);
            },
            emit() {
                this.userInput = true;
                this.$emit('input', this.instance.container.firstChild.innerHTML);
            },
            mapValues(option) {
                option.value = option[this.mentionFrom];
                return option;
            },
            emitMention(item, insertItem) {
                insertItem(item);
                this.$emit('mention', item);
            },
            renderMentions(searchTerm, renderList, mentionChar) {
                let values = this.atValues.filter(function (option) {
                    return option.value.toUpperCase().indexOf(searchTerm.toUpperCase()) != -1;
                });
                renderList(values.slice(0, 5), searchTerm);
            }
        }
    }
</script>

<style type="text/css">
.ql-picker-item[data-value='5px']::before, .ql-picker-label[data-value='5px']::before {
    content: '5px' !important;
}

.ql-picker-item[data-value='8px']::before, .ql-picker-label[data-value='8px']::before {
    content: '8px' !important;
}

.ql-picker-item[data-value='10px']::before, .ql-picker-label[data-value='10px']::before {
    content: '10px' !important;
}

.ql-picker-item[data-value='12px']::before, .ql-picker-label[data-value='12px']::before {
    content: '12px' !important;
}

.ql-picker-item[data-value='14px']::before, .ql-picker-label[data-value='14px']::before {
    content: '14px' !important;
}

.ql-picker-item[data-value='16px']::before, .ql-picker-label[data-value='16px']::before {
    content: '16px' !important;
}

.ql-picker-item[data-value='18px']::before, .ql-picker-label[data-value='18px']::before {
    content: '18px' !important;
}

.ql-picker-item[data-value='20px']::before, .ql-picker-label[data-value='20px']::before {
    content: '20px' !important;
}

.ql-picker-item[data-value='24px']::before, .ql-picker-label[data-value='24px']::before {
    content: '24px' !important;
}

.ql-picker-item[data-value='30px']::before, .ql-picker-label[data-value='30px']::before {
    content: '30px' !important;
}

.ql-picker-item[data-value='32px']::before, .ql-picker-label[data-value='32px']::before {
    content: '32px' !important;
}

.ql-picker-item[data-value='36px']::before, .ql-picker-label[data-value='36px']::before {
    content: '36px' !important;
}
</style>
